/**
 * Countries where Clari accepts signups — the "markets" list.
 *
 * Distinct concept from SWAN_ACCOUNT_COUNTRIES (where Swan opens an account):
 * signup is open across these markets, while account opening is residence-gated
 * to the Swan subset (de-facto waitlist for the rest). SINGLE SOURCE OF TRUTH:
 * the web signup <select> AND the API register validation both read this list,
 * so they can't diverge. Pilot a market by editing this one array.
 *
 * Invariant (asserted in tests): SWAN_ACCOUNT_COUNTRIES ⊆ SUPPORTED_SIGNUP_COUNTRIES
 * — we never open an account in a country we don't accept signups from.
 */
export const SUPPORTED_SIGNUP_COUNTRIES = [
    'FR',
    'DE',
    'ES',
    'IT',
    'NL',
    'PT',
    'PL',
    'BE',
    'LU',
    'IE',
    'AT',
];
const SET = new Set(SUPPORTED_SIGNUP_COUNTRIES);
/**
 * True if the alpha-2 country is a supported signup market.
 * Normalises case/whitespace; null/undefined/unknown → false.
 */
export function isSupportedSignupCountry(alpha2) {
    if (!alpha2)
        return false;
    return SET.has(alpha2.trim().toUpperCase());
}
//# sourceMappingURL=signup-countries.js.map